<template>
  <footer>
    <img
      class="logo-black"
      @click="skip('/')"
      src="@/assets/pcImg/logo-black.png"
    />
    <div class="line"></div>
    <div class="footer-content">
      <div class="about">
        <div class="title">ABOUT WEOPINIONS</div>
        <p>
          At the heart of our company is a global onlinecommunity, Your opinion
          is valuable Express opinions in “we opinions” and Earn rewards;
        </p>
      </div>
      <div class="glibal">
        <div class="title">COMPANY</div>
        <div class="ietnam">
          <div @click="skip('/logon')">Join panel</div>
          <!-- <div>Panelist</div> -->
          <div @click="skip('/aboutQuestionnaire')">About us</div>
          <div @click="skip('/helpFeedback')">Contact us</div>
        </div>
      </div>
      <div class="compaly">
        <div class="title">GLOBAL SITES</div>
        <div class="box-tow">
          <div class="box">
            <div @click="goHerf('https://www.weopinions.com/')">English</div>
            <div @click="goHerf('https://jp.weopinions.com/')">Japanese</div>
            <div @click="goHerf('https://kr.weopinions.com/')">한국</div>
            <div @click="goHerf('https://vn.weopinions.com/')">Việt Nam</div>
            <div @click="goHerf('https://th.weopinions.com/')">ประเทศไทย</div>
            <div @click="goHerf('https://la.weopinions.com/')">ລາວ</div>
            <div>Brunei</div>
            <div>Sri Lanka</div>
          </div>
          <div class="box">
            <div @click="goHerf('https://id.weopinions.com/')">Indonesia</div>
            <div @click="goHerf('https://mas.weopinions.com/')">Malaysia</div>
            <div @click="goHerf('https://tw.weopinions.com/')">中國臺灣</div>
            <div @click="goHerf('https://hk.weopinions.com/')">中国香港</div>
            <div @click="goHerf('https://nz.weopinions.com/')">New Zealand</div>
            <div>မမြန်န်မာ</div>
            <div>Nepal</div>
            <div>اسلامی جمہوریہ پاکستان‌</div>
          </div>
          <div class="box">
            <div @click="goHerf('https://sg.weopinions.com/')">Singapore</div>
            <div @click="goHerf('https://au.weopinions.com/')">Australia</div>
            <div @click="goHerf('https://ph.weopinions.com/')">Filipino</div>
            <div @click="goHerf('https://in.weopinions.com/')">भारत</div>
            <div @click="goHerf('https://kh.weopinions.com/')">កម្្ពុជា</div>
            <div>‌МОНГОЛ‌</div>
            <div>Bangladesh</div>
            <div>Bhutan</div>
          </div>
          <!-- <div class="box">
            <div @click="goHerf('https://mas.weopinions.com/')">Malaysia</div>
            <div @click="goHerf('https://tw.weopinions.com/')">中國臺灣</div>
            <div @click="goHerf('https://hk.weopinions.com/')">中國香港</div>
            <div @click="goHerf('https://sg.weopinions.com/')">Singapore</div>
            <div @click="goHerf('https://au.weopinions.com/')">Australia</div>
          </div>
          <div class="box">
            <div @click="goHerf('https://ph.weopinions.com/')">
              ang Pilipinas
            </div>
            <div @click="goHerf('https://in.weopinions.com/')">भारत</div>
            <div @click="goHerf('https://en.weopinions.com/')">England</div>
            <div @click="goHerf('https://nz.weopinions.com/')">New Zealand</div>
            <div @click="goHerf('https://rus.weopinions.com/')">Россия</div>
          </div>
          <div class="box">
            <div @click="goHerf('https://lu.weopinions.com/')">
              LëtzebuergName
            </div>
            <div @click="goHerf('https://za.weopinions.com/')">South Africa</div>
            <div @click="goHerf('https://fr.weopinions.com/')">France</div>
            <div @click="goHerf('https://de.weopinions.com/')">Deutschland</div>
            <div @click="goHerf('https://Ita.weopinions.com/')">Italia</div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="footer-imgs">
      <img src="@/assets/pcImg/facebook.png" />
      <img src="@/assets/pcImg/bird.png" />
      <img src="@/assets/pcImg/in.png" />
    </div>
    <div class="line"></div>

    <div class="copyright">
      <div>Copyright © 2022 Weopinions. All Rights Reserved.</div>
      <div>
        <a @click="skip('/privacyClauses/2')">Privacy & Terms</a> <span></span>
        <a @click="cookies">Cookies notice & Conditions</a>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  methods: {
    // 跳转
    skip(url) {
      this.$router.push({
        path: url,
      });
    },
    goHerf(href) {
      location.href = href;
    },

    cookies() {
      console.log("cookies");
      this.$store.commit("setCookieNoticeShow", true);
    },
  },
};
</script>
<style scoped>
/* 页脚 */
footer {
  width: calc(100% - 175px);
  min-height: 416.875px;
  background: #f4f5f5;
  padding-left: 87.25px;
  padding-right: 87.25px;
  margin-top: 20px;
}
.logo-black {
  width: 155.625px;
  height: 31.25px;
  margin-top: 47.5px;
  margin-bottom: 15px;
  cursor: pointer;
}
footer > .line {
  width: 100%;
  height: 0px;
  opacity: 1;
  border-top: 1px solid #e9ecee;
}
.footer-content {
  display: flex;
  justify-content: space-between;
  /* padding-right: 50px; */
  margin-top: 30px;
}
.footer-content .title {
  font-size: 10px;
  font-weight: bold;
  color: #232323;
}
.footer-content .about {
  width: 255px;
}
.footer-content .about p {
  margin-top: 21.875px;
  font-size: 8.75px;
  line-height: 18.125px;
}
.compaly > .box-join {
  font-size: 8.75px;
  margin-top: 30px;
}
.compaly > .box-join > div {
  margin-bottom: 11px;
}
.compaly > .box-tow {
  display: flex;
  font-size: 8.75px;
  margin-top: 18.75px;
}

.compaly > .box-tow > .box {
  margin-right: 46px;
}
.compaly > .box-tow > .box > div {
  min-width: 56px;
  margin-bottom: 16.25px;
  cursor: pointer;
}
.glibal > .ietnam {
  font-size: 8.75px;
  margin-top: 18.75px;
}
.glibal > .ietnam > div {
  margin-bottom: 16.25px;
  cursor: pointer;
}
.footer-imgs {
  display: flex;
  margin-top: 16.25px;
  margin-bottom: 25px;
}
.footer-imgs > img {
  width: 28.75px;
  height: 28.75px;
  margin-right: 15px;
}
.copyright {
  display: flex;
  justify-content: space-between;
  font-size: 8.75px;
  font-weight: 500;
  color: #232323;
}
.copyright > div {
  margin-top: 31.25px;
}
.copyright a {
  color: #232323;
  cursor: pointer;
}
span {
  height: 8px;
  border-left: 1px solid #707070;
  display: inline-block;
  margin-left: 11px;
  margin-right: 11px;
}
</style>
<style scoped>
@media only screen and (max-width: 900px) {
  footer {
    width: calc(100% - 37.5px);
    min-height: 416.875px;
    background: #f4f5f5;
    padding-left: 18.75px;
    padding-right: 18.75px;
    padding-bottom: 20px;
    margin-top: 20px;
  }
  .logo-black {
    margin-top: 20px;
  }
  .footer-content {
    flex-wrap: wrap;
  }
  .footer-content .about {
    width: 100%;
    margin-bottom: 20px;
  }
  .copyright {
    flex-wrap: wrap;
  }
  .copyright > div {
    text-align: center;
    width: 100%;
    margin-top: 15px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mycom/footer.vue